// Static content for the andAbout for Hotels landing page.
export const CHIPS = [
  { icon: "Waves", label: "Day passes" },
  { icon: "UtensilsCrossed", label: "Romantic dinners" },
  { icon: "ChefHat", label: "Cooking classes" },
  { icon: "Ship", label: "Tours & excursions" },
  { icon: "Flower2", label: "Spa & wellness" },
  { icon: "PartyPopper", label: "Events & brunches" },
  { icon: "Sun", label: "Pool & beach club" },
];

export const BENEFITS = [
  {
    icon: "LayoutGrid",
    title: "Every experience, one profile",
    body: "List your day passes, dinners, classes, spa and tours side by side. Guests browse, pick and book without calling the front desk.",
  },
  {
    icon: "CalendarCheck2",
    title: "Direct bookings & ticketing",
    body: "A commission-free booking engine for experiences, plus ticketing and RSVP for your events and brunches. From discovery to decision, seamlessly in-app.",
  },
  {
    icon: "Languages",
    title: "Multilingual menus",
    body: "Your menus, automatically translated for every guest, whatever language they speak.",
  },
  {
    icon: "Users",
    title: "Sales agents, one dashboard",
    body: "Manage all your inventory and sales agents in one place, and let them do the work for you. Every agent sells from live availability, every sale is tracked.",
  },
];

export const AUDIENCES = [
  {
    tag: "01",
    heading: "Your guests",
    body: "Browse and book everything you offer from their phone. No concierge queue, no phone calls, no missed revenue after 10pm.",
  },
  {
    tag: "02",
    heading: "Every tourist",
    body: "Travelers staying elsewhere discover your day passes, dinners and classes when they search for things to do right now.",
  },
  {
    tag: "03",
    heading: "Locals",
    body: "Residents become weekday regulars for your brunches, spa and events, filling the capacity your guests leave empty.",
  },
];

export const STEPS = [
  {
    n: "1",
    title: "Claim your property",
    body: "Your profile may already exist, pre-populated and ready. Claim it and make it yours in minutes.",
  },
  {
    n: "2",
    title: "List your experiences",
    body: "Add your day passes, dinners, classes, tours and events with prices, schedules and availability.",
  },
  {
    n: "3",
    title: "Sell to the whole island",
    body: "Guests, tourists and locals discover and book directly. You keep every baht of the sale.",
  },
];

export const PLANS = [
  {
    name: "Plus",
    price: "฿3,000",
    cadence: "/mo",
    note: "or ฿30,000/yr, two months free",
    features: [
      "Commission-free booking engine, up to 3 concurrent experiences",
      "Event ticketing & RSVP, up to 3 concurrent paid events",
      "Multilingual translated menus",
      "Follower management & lists",
      "Sales agent management",
      "Up to ฿150,000/mo in sales",
    ],
    cta: "Start with Plus",
    recommended: false,
  },
  {
    name: "Partner",
    price: "฿10,000",
    cadence: "/mo",
    note: "or ฿100,000/yr, two months free",
    features: [
      "Unlimited experiences & events",
      "Unlimited sales volume",
      "Commission-free bookings & ticketing",
      "Multilingual translated menus",
      "Follower management & lists",
      "Sales agent management",
      "Priority partner support",
    ],
    cta: "Claim your property",
    recommended: true,
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB0cm9waWNhbCUyMHJlc29ydCUyMHBvb2x8ZW58MHx8fHwxNzg1MjkyODg3fDA&ixlib=rb-4.1.0&q=85",
  pool: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB0cm9waWNhbCUyMHJlc29ydCUyMHBvb2x8ZW58MHx8fHwxNzg1MjkyODg3fDA&ixlib=rb-4.1.0&q=85",
  dinner: "https://images.unsplash.com/photo-1611862842460-0f5520500383",
  dinner2: "https://images.unsplash.com/photo-1686766149379-f986ce272232?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHx0aGFpJTIwY29va2luZyUyMGNsYXNzfGVufDB8fHx8MTc4NTI5NDUwN3ww&ixlib=rb-4.1.0&q=85",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/fjfgg0j8_andabout%20fix-04.webp",
  spa: "https://images.unsplash.com/photo-1488345979593-09db0f85545f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzcGElMjB3ZWxsbmVzc3xlbnwwfHx8fDE3ODUyOTI4OTh8MA&ixlib=rb-4.1.0&q=85",
  wellness: "https://images.pexels.com/photos/18120173/pexels-photo-18120173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const LOGOS = [
  "Anantara",
  "Four Seasons",
  "Banyan Tree",
  "Amari",
  "Nikki Beach",
  "Tembo",
  "Cabanas",
  "Bandara",
];
